import TableCheckbox from "../AcreditacionesVerificados/TableCheckbox";
import Pencil from "../../assets/img/pencil.svg";
import EditarPersona from "./EditarPersona";
import { useState } from "react";

const PersonaAgregada = ({ periodista, setSelected, selectedPeriodistas }) => {
  const [currentPeriodista, setCurrentPeriodista] = useState(periodista);
  const [editOpen, setEditOpen] = useState(false);
  const isSelected = selectedPeriodistas.includes(currentPeriodista);

  const handleClick = () => {
    if (editOpen) return;
    setSelected((prevState) =>
      !isSelected
        ? [...prevState, currentPeriodista]
        : prevState.filter((p) => p !== currentPeriodista)
    );
  };

  const handleEditOpen = () => {
    setEditOpen((prevState) => !prevState);
  };

  return (
    <div className={`agregada ${isSelected ? "active" : ""}`}>
      <div>
        <h5>{currentPeriodista.nombre}</h5>
        <span className="desc">{currentPeriodista.cargo}</span>
      </div>
      <p>
        <span className="fw500">DNI:</span>
        {currentPeriodista.dni}
      </p>
      <p>{currentPeriodista.mail}</p>
      <p>{currentPeriodista.celular}</p>
      <div className="icono-texto" onClick={handleEditOpen}>
        <img src={Pencil} alt="Editar" />
        <p>Editar</p>
      </div>
      <TableCheckbox isChecked={isSelected} onClick={handleClick} />
      <EditarPersona
        periodista={currentPeriodista}
        setPeriodista={setCurrentPeriodista}
        isOpen={editOpen}
        setIsOpen={setEditOpen}
      />
    </div>
  );
};

export default PersonaAgregada;
